
export const common = {
  sidebar: {
    title: "ระบบบริหารคลินิก",
    dashboard: "ภาพรวม (Dashboard)",
    kiosk: "จุดลงทะเบียน (Kiosk)", 
    telemedicine: "ห้องตรวจแพทย์",
    pharmacy: "ห้องจ่ายยา",
    customers: "ทะเบียนผู้ป่วย (ค้นหา)",
    inventory: "คลังยา & เวชภัณฑ์",
    reports: "รายงานผล",
    compliance: "รายงาน (Compliance)",
    employees: "บุคลากร",
    accounting: "บัญชีและการเงิน",
    partnerNetwork: "เครือข่ายพันธมิตร",
    billing: "แพ็กเกจและการชำระเงิน",
    settings: "ตั้งค่าระบบ",
    security: "ความปลอดภัยข้อมูล (PDPA)",
    platformAdmin: "คอนโซลผู้ดูแลระบบ (Super Admin)",
    profile: "ข้อมูลส่วนตัว (My Profile)"
  },
  header: {
    logout: "ออกจากระบบ"
  },
  logoutConfirm: {
    title: "ยืนยันการออกจากระบบ",
    message: "คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบ?",
    confirmButton: "ออกจากระบบ"
  }
};
